<template>
  <b-modal id="modal-success" hide-footer centered>
    <div class="col-12 d-flex flex-column align-items-center">
      <img
        class="centerImg1"
        src="@/assets/images/icons/checkbox-circle-line.svg"
      />
      <h2 class="pt-5 font-weight-bold">¡Proceso exitoso!</h2>
      <label
        class="pb-2 table-value"
        style="
          color: #455a64;
          margin-bottom: 16px;
          text-align: center;
          margin-top: 10px;
        "
        >{{ messageModal }}</label
      >
      <div v-if="getUsersNotAdded?.notBelongUsers?.length > 0" class="w-100">
        <b-alert show variant="warning" class="alert-warning-message mb-5">
          <p style="font-size: 16px; color: #263238">
            Empleados que no estan dentro de la misma ubicación ({{
              getUsersNotAdded?.notBelongUsers?.length
            }}):
          </p>
          <div class="d-flex">
            <div class="mr-3">
              <img
                src="@/assets/images/icons/alert-line.svg"
                alt=""
                width="28px"
                height="28px"
              />
            </div>
            <ul>
              <li
                style="font-size: 16px; color: #263238"
                v-for="(user, index) in getUsersNotAdded?.notBelongUsers"
                :key="index"
              >
                CC. {{ user?.cc }} - {{ user?.name }}
              </li>
            </ul>
          </div>
        </b-alert>
      </div>
      <div v-if="getUsersNotAdded?.usersNotExist?.length > 0" class="w-100">
        <b-alert show variant="warning" class="alert-warning-message mb-5">
          <p style="font-size: 16px; color: #263238">
            Empleados que no estan registrados ({{
              getUsersNotAdded?.usersNotExist?.length
            }}):
          </p>
          <div class="d-flex">
            <div class="mr-3">
              <img
                src="@/assets/images/icons/alert-line.svg"
                alt=""
                width="28px"
                height="28px"
              />
            </div>
            <ul>
              <li
                style="font-size: 16px; color: #263238"
                v-for="(user, index) in getUsersNotAdded?.usersNotExist"
                :key="index"
              >
                CC. {{ user?.cc }} - {{ user?.name }}
              </li>
            </ul>
          </div>
        </b-alert>
      </div>
      <div v-if="getUsersNotAdded?.usersWithGesInSVE?.length > 0" class="w-100">
        <b-alert show variant="warning" class="alert-warning-message mb-5">
          <p style="font-size: 16px; color: #263238">
            Empleados ya asociados a un GES ({{
              getUsersNotAdded?.usersWithGesInSVE?.length
            }}):
          </p>
          <div class="d-flex">
            <div class="mr-3">
              <img
                src="@/assets/images/icons/alert-line.svg"
                alt=""
                width="28px"
                height="28px"
              />
            </div>
            <ul>
              <li
                style="font-size: 16px; color: #263238"
                v-for="(user, index) in getUsersNotAdded?.usersWithGesInSVE"
                :key="index"
              >
                CC. {{ user?.cc }} - {{ user?.name }}
              </li>
            </ul>
          </div>
        </b-alert>
      </div>
      <OkayModal @click="$bvModal.hide('modal-success')"> Entendido </OkayModal>
    </div>
  </b-modal>
</template>

<script>
import OkayModal from "@/components/core/button/okay-modal.vue";

export default {
  components: {
    OkayModal
  },
  props: {
    messageModal: {
      type: String,
      default: "",
    },
    getUsersNotAdded: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped></style>
